import { TimechiefClient } from "../timechiefclient";

class GoogleMapsService {

    async geocode(options) {
        return TimechiefClient.default.geocode(options.lat, options.lng, options.term);
    }

    async updateDevice(deviceUUID, mapResult) {
        return TimechiefClient.default.getDeviceById(deviceUUID).then(device => {
            for (const [key, value] of Object.entries(mapResult)) {
                device[key] = value;
            }
            return TimechiefClient.default.updateDevice(device);
        });
    }
}

export const Service = new GoogleMapsService();